/**
 * Session Log API – check active session and record logout.
 * Uses same base URL as auth (pabws).
 */

import type {
  SessionActiveResponse,
  LogoutResponse,
  SessionValidateResponse,
} from "../types/session";

const API_BASE =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV ? "" : "https://pabauto.garage360.app/api");
const PABWS = "/pabws";

export async function checkSessionActiveByLoginName(
  loginName: string
): Promise<SessionActiveResponse | null> {
  const url = `${API_BASE}${PABWS}/users/session/active?login_name=${encodeURIComponent(loginName.trim())}`;
  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    return res.json();
  } catch {
    return null;
  }
}

export async function checkSessionActiveByUserId(
  userId: string
): Promise<SessionActiveResponse | null> {
  const url = `${API_BASE}${PABWS}/users/session/active?user_id=${encodeURIComponent(userId)}`;
  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    return res.json();
  } catch {
    return null;
  }
}

export async function logoutByUserId(userId: string): Promise<boolean> {
  try {
    const res = await fetch(`${API_BASE}${PABWS}/users/logout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id: userId }),
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function logoutByLoginName(loginName: string): Promise<boolean> {
  try {
    const res = await fetch(`${API_BASE}${PABWS}/users/logout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ login_name: loginName.trim() }),
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function validateSessionId(
  sessionId: string
): Promise<SessionValidateResponse | null> {
  const url = `${API_BASE}${PABWS}/users/session/validate?session_id=${encodeURIComponent(sessionId)}`;
  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    return res.json();
  } catch {
    return null;
  }
}
